import request, { Methods, withToken } from "../../../utils/request";
import { getUserCompany } from "../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const APPLY_PERSONNEL_ACTIONS_DEFAULT = "APPLY_PERSONNEL_ACTIONS_DEFAULT";
export const APPLY_PERSONNEL_ACTIONS_REQUEST = "APPLY_PERSONNEL_ACTIONS_REQUEST";
export const APPLY_PERSONNEL_ACTIONS_SUCCESS = "APPLY_PERSONNEL_ACTIONS_SUCCESS";
export const APPLY_PERSONNEL_ACTIONS_ERROR = "APPLY_PERSONNEL_ACTIONS_ERROR";

//* ACTIONS ------------------------------------------------
export const applyPersonnelActionsDefault = () => ({
  type: APPLY_PERSONNEL_ACTIONS_DEFAULT,
});

export const applyPersonnelActionsRequest = (payload = {}, callback) => ({
  type: APPLY_PERSONNEL_ACTIONS_REQUEST,
  payload,
  callback,
});

export const applyPersonnelActionsSuccess = (data) => ({
  type: APPLY_PERSONNEL_ACTIONS_SUCCESS,
  payload: data,
});

export const applyPersonnelActionsError = (error) => ({
  type: APPLY_PERSONNEL_ACTIONS_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const applyPersonnelActionsServiceRequest = async ({ personnelActionId, ...formData }) => {
  const options = await withToken({
    method: Methods.PUT,
    headers: { CompanyId: await getUserCompany() },
    data: { ...formData },
  });
  return request(`personnel_actions/${personnelActionId}/apply`, options);
};
